import { FC, Fragment, ReactNode, SyntheticEvent, useCallback } from "react";
import { TabList } from "@mui/lab";
import { Divider, Tab } from "@mui/material";

import { CommitmentDrawerTabType } from "@/components/pages/commtiments/common/components/drawer/utils/constants";

interface CommitmentDrawerTabsProps {
  onTabChange(tab: CommitmentDrawerTabType): void;
  tabs: {
    label: ReactNode;
    value: string;
    disabled?: boolean;
  }[];
}
export const CommitmentDrawerTabs: FC<CommitmentDrawerTabsProps> = ({
  onTabChange,
  tabs,
}) => {
  const handleGroupChange = useCallback(
    (_: SyntheticEvent, type: CommitmentDrawerTabType) => {
      onTabChange(type);
    },
    [onTabChange],
  );

  return (
    <Fragment>
      <TabList onChange={handleGroupChange} sx={{ bgcolor: "white" }}>
        {tabs.map((item) => {
          return (
            <Tab
              key={item.value}
              value={item.value}
              label={item.label}
              sx={{ textTransform: "none" }}
              disabled={item.disabled}
            />
          );
        })}
      </TabList>
      <Divider />
    </Fragment>
  );
};
